var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cashwheelPopup"},[_c('div',{staticClass:"cashwheelBox",attrs:{"id":'cashwheelBox' + _vm.id}},[_c('div',{staticClass:"swiper-wrapper"},_vm._l((_vm.source),function(item){return _c('div',{key:item.id,staticClass:"swiper-slide",attrs:{"dataRoute":item.routerUrl || ''}},[_c('img',{attrs:{"src":item.fullImgUrl}})])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }